<template>
  <div>
    <el-row :gutter="14">
      <el-col :span="12">
        <complaint-user :user="vo.complaintBy" tag="投诉人"/>
      </el-col>
      <el-col :span="12">
        <complaint-user :user="vo.complaintTo" tag="被投诉人"/>
      </el-col>
    </el-row>

    <el-collapse v-model="activeNames">
      <el-collapse-item name="1" title="基本信息">
        <info :infos="[
        {label:'ID',value:vo.id},
        {label:'投诉类型',value:vo.type},
        {label:'投诉内容',value:vo.content},
        {label:'创建时间',value:vo.createdAt}
    ]"></info>
      </el-collapse-item>
      <el-collapse-item name="2" title="投诉上下文聊天记录">
        <div class="msg-list">
          <div v-for="(msg, index) in vo.msgs" :key="index" class="msg-item">
            <div class="msg-title">
              <div class="msg-user">
                <div class="msg-user-avatar">
                  <cloud-img :border-radius="4" :img-height="20" :img-width="20" :url="msg.sender.avatar"></cloud-img>
                </div>
                <div class="msg-user-name">
                  {{ msg.sender.nickname }}
                </div>
              </div>
              <div class="msg-time">
                {{ msg.createTime }}
              </div>
            </div>
            <div class="msg-content">
              {{ msg.content }}
            </div>
          </div>
        </div>


      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import {complaint} from "@/api/miu/complaint";
import Info from "@/components/system/Info.vue";
import CloudImg from "@/components/base/layout/img/CloudImg.vue";
import ComplaintUser from "@/components/ComplaintUser.vue";

export default {
  name: 'ComplaintDetail',
  components: {
    ComplaintUser,
    CloudImg,
    Info
  },

  props: {
    id: Number,
  },

  data() {
    return {
      vo: {},
      activeNames: ['1']
    }
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      complaint.detail(this.id).then(res => {
        this.vo = res.data;
        console.log("this.vo:");
        console.log(this.vo);
      });
    }
  }

};
</script>

<style scoped>

.msg-user {
  display: flex;
}

.msg-title {
  display: flex;
  justify-content: space-between;
  color: #959595;
}

.msg-time {
  color: #bdbdbd;
}

.msg-content {
  color: #333333;
}

.msg-list {
  display: flex;
  flex-direction: column;
}

/* .msg-item 之间有横线*/
.msg-item:not(:last-child) {
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 6px;
  padding-top: 6px;
}

/*鼠标移动到msg-item上去，样式变化*/
.msg-item:hover {
  background-color: #f5f5f5;
}

</style>
